import { cleanSize, clampPage } from '../components/kit/flow'
import { formatDay } from './dateRules'

// "Dates to check" (release 3.3, M4): the decisions of the page, as plain
// functions test/dates-to-check.test.mjs can call. The list itself is the
// server's (GET /v1/reports/dates-to-check, repo/dates_to_check.go): stored
// dates that break D1 or D6 and must be corrected before the stricter check is
// switched on, and those carrying D2, D3 or D8 that are worth a look.

export type DateRowKind = 'error' | 'warning'

// The word in the first column: an error is a date a save would now refuse.
export function kindWord(kind: DateRowKind): string {
  return kind === 'error' ? 'To fix' : 'Worth a look'
}

// The two dates as one line: "1 Nov 2026 to 31 Oct 2027".
export function datesLine(from?: string, to?: string): string {
  if (from && to) return formatDay(from) + ' to ' + formatDay(to)
  if (to) return 'Ends ' + formatDay(to)
  if (from) return 'From ' + formatDay(from)
  return 'No dates'
}

// The page and size the address asks for, cleaned: #/report/dates-to-check?page=2&size=50.
export function readPaging(hash: string): { page: number; size: number } {
  const q = new URLSearchParams(hash.split('?')[1] ?? '')
  const page = Math.max(1, Math.floor(Number(q.get('page')) || 1))
  return { page, size: cleanSize(Number(q.get('size')) || undefined) }
}

// The address for a page, which the screen REPLACES (paging is not a history step).
export function pagingHash(page: number, size: number): string {
  return '#/report/dates-to-check?page=' + page + '&size=' + size
}

// A page past the end comes back empty (the list shrank after the person
// fixed rows, or Back reopened an old address): go to the first page rather
// than show a blank report (review of M4, S5). null when the page stands.
export function pageAfterEmpty(page: number, rows: number): number | null {
  return rows === 0 && page > 1 ? 1 : null
}

// The server's limit and offset for a page, once the total is known the page
// is clamped so a stale address past the end shows the last page.
export function pageQuery(page: number, size: number, total?: number): { limit: number; offset: number } {
  const p = total === undefined ? page : clampPage(page, total, size)
  return { limit: size, offset: (p - 1) * size }
}
